import React, { Component } from "react";
import { strings } from "../../../constants/strings";
import { Accordion, Card, Button, Modal } from "react-bootstrap"
import { wpmTexts } from "../../../helpers/wpmTextsProvider";

export default class TextArea extends Component {
  constructor (props){
    super(props)
    this.state = {
      cardHeaderSelectedIndex: 1
    }
  }
  render() {
    return (
      <>
        <div className='d-flex mb-4 mt-4'>
          <span className='selected-text-text'
          >{strings.SLMB_Text}</span>
          <span
            className='selected-text-button'
            onClick={this.props.showTxtSelector}>
            {this.props.textName}
          </span>
        </div>
        <Modal
          contentClassName='wpm-test-text-selector'
          show={this.props.textSelectorIsVisible}
          onHide={this.props.hideTxtSelector}
        >
          <div className='text-selector-header'>
          {strings.SLMB_Text}
          </div>
          <Modal.Body
            style={
              {
                padding: 0
              }
            }
          >
            <Accordion defaultActiveKey={String(this.props.textLevel)}>
              {
                Object.keys(wpmTexts).map((lvlKey, index) => {
                  if (index !== 0) {
                    return (
                      <Card key={lvlKey}>
                        <Card.Header  className={this.state.cardHeaderSelectedIndex === index?'selected':''}>
                          <Accordion.Toggle
                            className={this.props.textLevel === index ? 'text-level selected' : 'text-level'}
                            as={Button}
                            onClick={()=>{
                              if(this.state.cardHeaderSelectedIndex === index) {
                                this.setState({cardHeaderSelectedIndex: ''})
                              } else {                                
                                this.setState({cardHeaderSelectedIndex: index})
                              }
                            }}
                            variant="link"
                            eventKey={lvlKey}
                          >
                            {strings.web_textlist_difficulty} {lvlKey}
                          </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey={lvlKey}>
                          <Card.Body>
                            <ul>
                              {
                                Object.keys(wpmTexts[lvlKey]).map((textKey, key) => {
                                  return (
                                    <li className={this.props.textName === wpmTexts[lvlKey][textKey].name ? "selected" : ''}
                                      onClick={() => {
                                        this.props.hideTxtSelector()
                                        this.props.setText(wpmTexts[lvlKey][textKey], index)
                                      }}
                                      key={textKey}>{wpmTexts[lvlKey][textKey].name}</li>
                                  )
                                })
                              }
                            </ul>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    )
                  }
                })
              }
            </Accordion>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
